import { Component, OnInit } from '@angular/core';
import { UserService } from "../services/user/user.service";
import { ActivatedRoute, ParamMap } from '@angular/router';
@Component({
  selector: 'app-commandes',
  templateUrl: './commandes.component.html',
  styleUrls: ['./commandes.component.css']
})
export class CommandesComponent implements OnInit {
  listCommandes:any;
  total = 0;
  perpage = 10;
  nbrPages = 1;
  currentPage = 1;
  pages:any=[];
  startDate = '';
  endDate = '';
  constructor(public userService:UserService,private route: ActivatedRoute) { }

  ngOnInit(): void {
     // parseInt(this.route.snapshot.paramMap.get('page'));
    this.route.params.subscribe((params) => {
      this.currentPage = parseInt(params.page)
      this.userService.getCommandes(this.currentPage).subscribe(res=>{
        this.total =  res["total"];


        this.nbrPages = Math.trunc( this.total / this.perpage ) + 1;
        this.pages = [];
        for (let index = 1; index < this.nbrPages+1; index++) {
          this.pages.push(index)
        }

        this.listCommandes = res["data"];
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      })
    })

  }

  filtre(){
    if(this.startDate != '' && this.endDate != '' ){
      this.userService.orderBetweenDates(this.startDate,this.endDate).subscribe(res=>{
        this.total =  res["total"];


        this.nbrPages = Math.trunc( this.total / this.perpage ) + 1;
        this.pages = [];
        for (let index = 1; index < this.nbrPages+1; index++) {
          this.pages.push(index)
        }

        this.listCommandes = res["data"];
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      })
    }else{
      this.ngOnInit()
    }

  }

}
